module.exports = __webpack_public_path__ + "static/media/scroll_copy.715189aa.svg";